export default "__VITE_ASSET__BfsbJc9j__"